import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Form,
  Row,
  Input,
  Label,
  Button,
  Spinner,
} from "reactstrap";
import Select from "react-select";
import swal from "sweetalert";
import { useNavigate, useSearchParams } from "react-router-dom";

import {
  _Get,
  _PostSave,
  _Put,
  CreateCustomerList,
  ViewCompanyDetails,
} from "../../ApiEndPoint/ApiCalling";

import {
  Create_Payment,
  Update_payment_By_Id,
  View_Receipt_By_Id,
  View_Expense_Account,
  Create_Account_List,
  Create_Transporter_List,
} from "../../ApiEndPoint/Api";
import axiosConfig from "../../AxiosConfig"
export default function CreatePayment() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const view = searchParams.get("view");
  const id = view?.split("-")[2];

  const isEdit = id && id !== "0";

  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(true);

  const [partyList, setPartyList] = useState([]);
  const [bankList, setBankList] = useState([]);

  const [formValues, setFormValues] = useState({
    date: "",
    paymentMode: "",
    amount: "",
    remark: "",
    partyId: "",
    userId: "",
    expenseId: "",
    bankId: "",
    type: "payment",
  });

  // ✅ Fetch All Data (Party + User + Expense)
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const user = JSON.parse(localStorage.getItem("userData"));
  //       const url = `${Create_Account_List + user?._id}/`;

  //       const [customerRes, userRes, expenseRes] = await Promise.all([
  //         _Get(url, user?.database),
  //         _Get(url, user?.database),
  //         _Get(View_Expense_Account, user?.database),
  //       ]);

  //       const customers =
  //         customerRes?.Customer?.map((c) => ({
  //           label: c.CompanyName,
  //           value: c._id,
  //           type: "party",
  //         })) || [];

  //       const users =
  //         userRes?.adminDetails?.map((u) => ({
  //           label: u.firstName,
  //           value: u._id,
  //           type: "user",
  //         })) || [];

  //       const expenses =
  //         expenseRes?.Expenses?.map((e) => ({
  //           label: `${e.title} ${e.type}`,
  //           value: e._id,
  //           type: "expense",
  //         })) || [];

  //       setPartyList([...customers, ...users, ...expenses]);
  //     } catch (err) {
  //       swal("Error loading particulars");
  //     } finally {
  //       setLoader(false);
  //     }
  //   };

  //   fetchData();
  // }, []);

  useEffect(() => {
   
    let userdata = JSON.parse(localStorage.getItem("userData"));
    let url = `${Create_Account_List + userdata?._id}/`;
    const fetchData = async () => {
      try {
        const [CustomeData, UserData, ExpensesData, TransporterList] =
          await Promise.allSettled([
            CreateCustomerList(userdata?._id, userdata?.database),
            _Get(url, userdata?.database),
            _Get(View_Expense_Account, userdata?.database),
            _Get(Create_Transporter_List, userdata?.database),
          ]);
        if (TransporterList?.value?.Transporter?.length > 0) {
          TransporterList?.value?.Transporter?.forEach((element) => {
            element["transporter"] = true;
            element["fullName"] = element?.companyName;
          });
        }
        if (CustomeData?.value?.Customer?.length > 0) {
          CustomeData?.value?.Customer?.forEach((element) => {
            element["party"] = true;
            element["fullName"] = element?.CompanyName;
          });
        }
        if (UserData?.value?.adminDetails?.length > 0) {
          UserData?.value?.adminDetails?.forEach((element) => {
            element["User"] = true;
            element["fullName"] = element?.firstName;
          });
        }
        if (ExpensesData?.value?.Expenses?.length > 0) {
          ExpensesData?.value?.Expenses?.forEach((element) => {
            element["miscellaneous"] = true;
            element["fullName"] = `${element?.title} ${element?.type}`;
          });
        }
        let Transporter = TransporterList?.value?.Transporter
          ? TransporterList?.value?.Transporter
          : [];
        let customer = CustomeData?.value?.Customer
          ? CustomeData?.value?.Customer
          : [];
        let User = UserData?.value?.adminDetails
          ? UserData?.value?.adminDetails
          : [];
        let Expenses = ExpensesData?.value?.Expenses
          ? ExpensesData?.value?.Expenses
          : [];
    let wholeData = [
  ...customer,
  ...User,
  ...Expenses,
  ...Transporter,
];

const options = wholeData.map((item) => ({
  ...item,
  label: item?.fullName || item?.CompanyName || item?.firstName || item?.title || "",
  value: item?._id,
}));

console.log("SELECT OPTIONS =>", options);

setPartyList(options);
      } catch (error) {
        // setError(error);
        setLoader(false);
      } finally {
        setLoader(false);
      }
    };

    fetchData();
  }, []);

  // ✅ Fetch Banks
  // useEffect(() => {
  //   const fetchBanks = async () => {
  //     const user = JSON.parse(localStorage.getItem("userData"));
  //     const res = await ViewCompanyDetails(user?._id, user?.database);

  //     const banks =
  //       res?.CompanyDetail?.bankDetails?.map((b) => ({
  //         label: b.bankName,
  //         value: b._id,
  //       })) || [];

  //     setBankList(banks);
  //   };

  //   fetchBanks();
  // }, []);

  // ✅ Edit Mode Load
  useEffect(() => {
  if (!isEdit || !id) return;

  const fetchPaymentById = async () => {
    try {
      setLoading(true);

      const res = await axiosConfig.get(
        `/receipt/view-receipt-by-id/${id}`
      );

      console.log("PAYMENT EDIT RESPONSE =>", res);
      console.log("PAYMENT DATA =>", res?.data?.Receipts);

      const d = res?.data?.Receipts;

      if (!d) {
        swal("Error", "Payment data not found!", "error");
        return;
      }

      const updatedForm = {
        date: d?.date
          ? d.date.split("T")[0]
          : "",
        paymentMode: d?.paymentMode || "",
        amount: d?.amount || "",
        remark: d?.remark || "",
        type: "payment",
        partyId: "",
        userId: "",
        expenseId: "",
        transporterId: "",
        bankId: "",
      };

      // Particular
      if (d?.partyId?._id) {
        updatedForm.partyId = d.partyId._id;
      } else if (d?.userId?._id) {
        updatedForm.userId = d.userId._id;
      } else if (d?.expenseId?._id) {
        updatedForm.expenseId = d.expenseId._id;
      } else if (d?.transporterId?._id) {
        updatedForm.transporterId = d.transporterId._id;
      }

      // Bank
      if (d?.bankId?._id) {
        updatedForm.bankId = d.bankId._id;
      } else if (d?.bankId) {
        updatedForm.bankId = d.bankId;
      }

      console.log("FINAL EDIT FORM =>", updatedForm);

      setFormValues(updatedForm);

    } catch (error) {
      console.log(
        "PAYMENT EDIT ERROR =>",
        error?.response?.data || error
      );

      swal(
        "Error",
        "Error loading payment!",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  fetchPaymentById();
}, [isEdit, id]);

  // ✅ Submit
  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   const user = JSON.parse(localStorage.getItem("userData"));

  //   const payload = {
  //     Payment: [
  //       {
  //         ...formValues,
  //         created_by: user?._id,
  //         database:user?.database
  //       },
  //     ],
  //   };

  //   try {
  //     setLoading(true);

  //     if (!isEdit) {
  //       debugger
  //       await _PostSave(Create_Payment, payload);
        
  //       swal("Payment Created");
  //     } else {
  //       await _Put(Update_payment_By_Id, id, payload.Payment[0]);
  //       swal("Payment Updated");
  //     }

  //     navigate("/transactions?view=payment");
  //   } catch (err) {
  //     swal("Error saving payment");
  //   } finally {
  //     setLoading(false);
  //   }
  // };


const handleSubmit = async (e) => {
  e.preventDefault();

  const user = JSON.parse(localStorage.getItem("userData"));

  const payment = {
    date: formValues.date,
    paymentMode: formValues.paymentMode,
    amount: formValues.amount,
    remark: formValues.remark,
    type: formValues.type,

    created_by: user?._id,
    database: user?.database,
  };

  // Sirf jiski value hai wahi field payload me jayegi
  if (formValues.partyId) {
    payment.partyId = formValues.partyId;
  }

  if (formValues.userId) {
    payment.userId = formValues.userId;
  }

  if (formValues.expenseId) {
    payment.expenseId = formValues.expenseId;
  }

  // Bank selected hai tabhi bankId jayega
  if (formValues.bankId) {
    payment.bankId = formValues.bankId;
  }

  const payload = {
    Payment: [payment],
  };

  try {
    setLoading(true);

    if (!isEdit) {
      await _PostSave(Create_Payment, payload);

      // OK click hone ke baad hi navigate hoga
      await swal(
        "Payment Created",
        "Payment created successfully!",
        "success"
      );

      navigate("/transactions?view=payments");
    } else {
      await _Put(
        Update_payment_By_Id,
        id,
        payload.Payment[0]
      );

      await swal(
        "Payment Updated",
        "Payment updated successfully!",
        "success"
      );

      navigate("/transactions?view=payments");
    }

  } catch (err) {
    console.log("Payment Error =>", err);

    await swal(
      "Error",
      "Error saving payment!",
      "error"
    );
  } finally {
    setLoading(false);
  }
};




  if (loader) {
    return (
      <div className="text-center mt-3">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="erp-page-grid">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h2>{isEdit ? "Edit Payment" : "Add Payment"}</h2>

        <Button onClick={() => navigate("/transactions?view=payments")}>
          ← Back
        </Button>
      </div>

      <Card>
        <CardBody>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md="3">
                <Label>Date</Label>
                <Input
                  type="date"
                  value={formValues.date}
                  onChange={(e) =>
                    setFormValues({ ...formValues, date: e.target.value })
                  }
                />
              </Col>

              <Col md="3">
                <Label>Particular</Label>
                <Select
                  options={partyList}
                  value={partyList.find(
                    (p) =>
                      p.value ===
                      (formValues.partyId ||
                        formValues.userId ||
                        formValues.expenseId)
                  )}
                 onChange={(selected) => {
  if (!selected) {
    setFormValues({
      ...formValues,
      partyId: "",
      userId: "",
      expenseId: "",
    });
    return;
  }

  let updated = {
    partyId: "",
    userId: "",
    expenseId: "",
  };

  if (selected.party) {
    updated.partyId = selected.value;
  } else if (selected.User) {
    updated.userId = selected.value;
  } else if (selected.miscellaneous) {
    updated.expenseId = selected.value;
  } else if (selected.transporter) {
    updated.transporterId = selected.value;
  }

  setFormValues({
    ...formValues,
    ...updated,
  });
}}
                />
              </Col>

              <Col md="3">
                <Label>Payment Mode</Label>
                <Input
                  type="select"
                  value={formValues.paymentMode}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      paymentMode: e.target.value,
                      bankId:
                        e.target.value === "Bank"
                          ? formValues.bankId
                          : "",
                    })
                  }
                >
                  <option value="">Select</option>
                  <option>Cash</option>
                  <option>Bank</option>
                </Input>
              </Col>

              {formValues.paymentMode === "Bank" && (
                <Col md="3">
                  <Label>Select Bank</Label>
                  <Select
                    options={bankList}
                    value={bankList.find(
                      (b) => b.value === formValues.bankId
                    )}
                    onChange={(selected) =>
                      setFormValues({
                        ...formValues,
                        bankId: selected.value,
                      })
                    }
                  />
                </Col>
              )}

              <Col md="3">
                <Label>Amount</Label>
                <Input
                  type="number"
                  value={formValues.amount}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      amount: Number(e.target.value),
                    })
                  }
                />
              </Col>

              <Col md="3">
                <Label>Remark</Label>
                <Input
                  value={formValues.remark}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      remark: e.target.value,
                    })
                  }
                />
              </Col>
            </Row>

            <div className="mt-3 text-center">
              <Button color="primary" disabled={loading}>
                {loading ? "Saving..." : "Save"}
              </Button>
            </div>
          </Form>
        </CardBody>
      </Card>
    </div>
  );
}